// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail-mXJU1"};